'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var grey = require('../../node_modules/@material-ui/core/esm/colors/grey.js');
var TextField$1 = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TextField = function TextField(_ref) {
  var InputProps = _ref.InputProps,
      inputProps = _ref.inputProps,
      variant = _ref.variant,
      dataTestId = _ref["data-testid"],
      materialUIConfigurations = objectWithoutProperties(_ref, ["InputProps", "inputProps", "variant", "data-testid"]);

  var style = _objectSpread({}, InputProps.style);

  if (variant === 'filled') {
    style.backgroundColor = grey[100];
  }

  return React__default["default"].createElement(TextField$1["default"], _extends["default"]({
    variant: variant,
    InputProps: _objectSpread({}, InputProps, {
      style: style
    }),
    inputProps: _objectSpread({}, inputProps, {
      "data-testid": dataTestId
    })
  }, materialUIConfigurations));
};

TextField.defaultProps = {
  InputProps: {
    style: {}
  },
  inputProps: {},
  variant: 'filled'
};

module.exports = TextField;
